<template>
  <div class="card-content">
    <div id="menu-tab">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane :label="$t('菜谱订单')" name="RecipeOrder">
        </el-tab-pane>
        <el-tab-pane :label="$t('用户订单')" name="UserOrder">
        </el-tab-pane>
      </el-tabs>
    </div>
    <keep-alive>
      <component :is="activeName" :externalHeight="tabMenuHeight" />
    </keep-alive>
  </div>

</template>

<script>
import RecipeOrder from "@/components/order/RecipeOrder";
import UserOrder from "@/components/order/UserOrder";
export default {
  name: "OrderList",
  components: {UserOrder, RecipeOrder},
  data() {
    return {
      activeName: "RecipeOrder",
      tabMenuHeight: 0
    }
  },
  mounted() {
    this.handleResizeTableHeight();
  },
  methods: {
    // 监听表格内容高度
    handleResizeTableHeight() {
      this.$nextTick(() => {
        const wrapper = document.querySelector("#menu-tab");
        this.tabMenuHeight = (wrapper?.clientHeight || 0) + 40;
      })
    },
  }
}
</script>

<style scoped>
.card-content {
  background: #ffffff;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 12px;
}
</style>
